/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button, ModalConfirm } from "@nordcloud/gnui";
import { inflect } from "~/tools";
import { useDeleteRole } from "../hooks/useDeleteRole/useDeleteRole";

type Props = {
  roleIds: string[];
  isDeleteModalOpen: boolean;
  openModal: () => void;
  close: () => void;
  onSuccess?: () => void;
};

export function RolesDelete({
  roleIds,
  isDeleteModalOpen,
  openModal,
  close,
  onSuccess,
}: Props) {
  const [deleteRole] = useDeleteRole({
    onSuccess: () => {
      close();
      onSuccess?.();
    },
    onError: () => {
      close();
    },
  });

  function deleteRoles(ids: string[]) {
    return Promise.all(ids.map((id) => deleteRole(id)));
  }

  function onDelete(ids: string[]) {
    deleteRoles(ids);
  }

  return (
    <>
      <Button
        aria-label="delete button"
        data-testid="delete button"
        icon="trash"
        size="md"
        severity="low"
        onClick={openModal}
      />
      <ModalConfirm
        onClose={close}
        isOpen={isDeleteModalOpen}
        confirm={() => onDelete(roleIds)}
        actionLabel="Delete"
        data-testid="modal-delete-role"
        contentLabel={`Delete ${inflect("Role")(roleIds.length)}`}
      >
        {`Are you sure you want to delete ${inflect("Role")(roleIds.length)}?`}
      </ModalConfirm>
    </>
  );
}
